var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 320 320",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.677,138.71c22.919,0,41.807-17.567,43.921-39.943c2.114-0.439,3.704-2.312,3.704-4.556 c0-26.053-21.195-47.248-47.249-47.248c-2.244,0-4.116,1.589-4.555,3.703c-22.376,2.113-39.945,20.999-39.945,43.919 C87.553,118.915,107.347,138.71,131.677,138.71z M136.708,56.555c17.207,2.114,30.888,15.796,33.003,33.002h-33.003V56.555z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.648,167.236c0,3.855,3.125,6.98,6.981,6.98h126.586c3.856,0,6.981-3.126,6.981-6.98c0-3.855-3.125-6.981-6.981-6.981 H96.629C92.773,160.255,89.648,163.381,89.648,167.236z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.215,191.17H96.629c-3.855,0-6.981,3.125-6.981,6.981c0,3.855,3.125,6.981,6.981,6.981h126.586 c3.856,0,6.981-3.126,6.981-6.981C230.196,194.295,227.071,191.17,223.215,191.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.215,222.086H96.629c-3.855,0-6.981,3.125-6.981,6.98c0,3.855,3.125,6.981,6.981,6.981h126.586 c3.856,0,6.981-3.125,6.981-6.981C230.196,225.211,227.071,222.086,223.215,222.086z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.215,253.001H96.629c-3.855,0-6.981,3.126-6.981,6.98c0,3.855,3.125,6.981,6.981,6.981h126.586 c3.856,0,6.981-3.125,6.981-6.981C230.196,256.127,227.071,253.001,223.215,253.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.408,60.47L215.402,1.464C214.464,0.527,213.192,0,211.866,0H59.181c-8.3,0-15.053,6.753-15.053,15.054v289.893 c0,8.301,6.752,15.054,15.053,15.054h201.639c8.3,0,15.053-6.753,15.053-15.054V64.006C275.872,62.68,275.345,61.408,274.408,60.47 z M253.872,298H66.128V22h138.697h0.84v33.411c0,8.301,6.752,15.055,15.053,15.055h33.154V298z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.bda8d9e213282411c1e6c06336b1670e.svg";
export { ForwardRef as ReactComponent };